<cc-top-bar title="MENU.MOBILE_APP" [hideSubMenu]="true"></cc-top-bar>
<div class="w-full p-b-md v-c container h-full-vh justify-content-center">
  <div class="row col-lg-11 col-xs-12" layout>
    <div class="col-xs-12 col-md-5 hidden-sm-down">
      <img src="/assets/img/iPhoneX_app_screen.png"
           class="pull-right w-330 image-wrapper p-r-md lg-down-p-r-0">
    </div>
    <div class="col-xs-12 col-md-7 align-content-center p-x-md" layout layout-wrap>
      <h1 class="w-full md-phone-text-md title-mobile">{{'MOBILE_APP.CC_MOBILE' | translate}}</h1>

      <h3 class="title-margin-bottom w-full lg-down-text-sm _400 header-mobile">{{'MOBILE_APP.HEADER' | translate}}</h3>

      <h4  class="title-margin-bottom w-full lg-down-text-sm _400 subheader-mobile">{{'MOBILE_APP.SUBHEADER' | translate}}</h4>

      <ul class="list-wrapper p-l-1 w-full w-full lg-down-text-sm">
        <li class="m-b-1 text-green">
          <span class="list-text text-md text-black _400 lg-down-text-sm">{{'MOBILE_APP.USE_STEP_1' | translate}}</span>
        </li>
        <li class="m-b-1 text-green">
          <span class="list-text text-md text-black _400 lg-down-text-sm">{{'MOBILE_APP.USE_STEP_2' | translate}}</span>
        </li>
        <li class="m-b-1 text-green">
          <span class="list-text text-md text-black _400 lg-down-text-sm">{{'MOBILE_APP.USE_STEP_3' | translate}}</span>
        </li>
      </ul>
      <cc-mobile-store-buttons></cc-mobile-store-buttons>
    </div>
  </div>
</div>
